<template>
    <div class="nj-view-container"
         v-if="orden.codigo">
        <h1 class="subtitle">Orden de {{ orden.tipo_orden === 1 ? "Compra" : "Servicio" }}: {{ orden.codigo }}</h1>
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="columns">
                    <div class="column">
                        <label class="has-text-weight-semibold">Centro de Costo:</label>
                        <span class="is-pulled-right">{{ orden.centro_costo.codigo }} {{ orden.centro_costo.descripcion
                        }}</span>
                    </div>
                    <div class="column">
                        <label class="has-text-weight-semibold">Proveedor:</label>
                        <span class="is-pulled-right">{{ orden.proveedor.razon_social }}</span>
                    </div>
                    <div class="column">
                        <label class="has-text-weight-semibold">Moneda</label>
                        <span class="is-pulled-right">{{ orden.moneda.descripcion }}({{ orden.moneda.simbolo }})</span>
                    </div>
                    <div class="column">
                        <label class="has-text-weight-semibold">Base imponible</label>
                        <span class="is-pulled-right">{{ calcularBaseImponible() }}</span>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <label class="has-text-weight-semibold">Condición:</label>
                        <span class="is-pulled-right">{{ orden.condicion_comercial.descripcion }}</span>
                    </div>
                    <div class="column">
                        <label class="has-text-weight-semibold">Método de Pago</label>
                        <span class="is-pulled-right">{{ orden.metodo_pago.descripcion }}</span>
                    </div>
                    <div class="column">
                        <label class="has-text-weight-semibold">Tipo Comprobante</label>
                        <span class="is-pulled-right">{{ orden.tipo_documento.descripcion }}</span>
                    </div>
                    <div class="column">
                        <label class="has-text-weight-semibold">Numero comprobante</label>
                        <span class="is-pulled-right">{{ orden.ord_numero_documento }}</span>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-4">
                        <label class="has-text-weight-semibold">Fecha Pago:</label>
                        <span class="is-pulled-right">{{ orden.fecha_pago }}</span>
                    </div>
                    <div class="column is-8">
                        <label class="has-text-weight-semibold">Lugar de Entrega:</label>
                        <span class="is-pulled-right">{{ orden.lugar_entrega }}</span>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <label class="has-text-weight-semibold">Logística:</label>
                        <span class="is-pulled-right">{{ orden.logistica.nombre }} {{ orden.logistica.apellido }}</span>
                    </div>
                    <div class="column">
                        <label class="has-text-weight-semibold">Contabilidad:</label>
                        <span class="is-pulled-right">{{ orden.contabilidad.nombre }}
                            {{ orden.contabilidad.apellido }}</span>
                    </div>
                    <div class="column">
                        <label class="has-text-weight-semibold">Administración:</label>
                        <span class="is-pulled-right">{{ orden.administrador.nombre }}
                            {{ orden.administrador.apellido }}</span>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-4">
                        <label class="has-text-weight-semibold">Gerencia:</label>
                        <span class="is-pulled-right">{{ orden.gerencia.nombre }} {{ orden.gerencia.apellido }}</span>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <label class="has-text-weight-semibold">Referencia:</label>
                        <span class="is-pulled-right">{{ orden.referencia }}</span>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <label class="has-text-weight-semibold">Observación:</label>
                        <span class="is-pulled-right">{{ orden.observacion }}</span>
                    </div>
                </div>
                <div class="nj-buttons">
                    <button v-if="isMostrarPagos"
                            class="nj-button c-green"
                            @click="ordenesPago()"
                            style="width: 150px;"><i class="mdi mdi-coin"></i>Ordenes de Pago</button>
                    <Button label="Generar Transferencia"
                            icon="add"
                            @click="popup({ interfaz: 'TransferenciaOrdenCompra', activar: true })"></Button>
                    <Button label="Ver Transferencia"
                            icon="doc"
                            @click="popup({ interfaz: 'TransferenciaItemsDetallexOrdenView', activar: true })"></Button>
                </div>
                <br>
                <OrdenArchivos :orden="orden"></OrdenArchivos>
                <br>
                <div class="table-container">
                    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                        <thead>
                            <th class="is-link has-text-centered">Marca</th>
                            <th class="is-link">Descripción</th>
                            <th class="is-link has-text-centered">UND</th>
                            <th class="is-link has-text-centered">CANT.</th>
                            <th class="is-link has-text-centered">P.U.</th>
                            <th class="is-link has-text-centered">SUBTOTAL</th>
                            <th class="is-link">OBS</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in orden.orden_items"
                                :key="index">
                                <td class="has-text-centered">
                                    {{ item.marca.id_marca === 0 ? "-" : item.marca.descripcion }}
                                </td>
                                <td>{{ item.descripcion }}</td>
                                <td class="has-text-centered">{{ item.unidad.simbolo }}</td>
                                <td class="has-text-centered">{{ item.cantidad | amount }}</td>
                                <td class="has-text-centered">{{ item.precio_unitario | amount }}</td>
                                <td class="has-text-centered">
                                    {{ (item.precio_unitario * item.cantidad) | amount }}
                                </td>
                                <td>{{ item.observacion }}</td>
                            </tr>
                            <tr>
                                <td colspan="5">SubTotal:</td>
                                <td class="has-text-centered">{{ total_sin_impuesto | amount }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="4">Descuento:</td>
                                <td class="has-text-centered">
                                    {{ orden.descuento }}{{ orden.tipo_descuento === 1 ? "%" : "" }}
                                </td>
                                <td class="has-text-centered">{{ total_con_descuento | amount }}</td>
                                <td></td>
                            </tr>
                            <!-- aqui se renderiza los impuestos de la orden -->
                            <tr v-for="(item, index) in orden.orden_impuestos"
                                :key="index + '_tax'">
                                <td colspan="4">{{ item.descripcion }}</td>
                                <td class="has-text-centered">{{ item.valor | percentage }}</td>
                                <td class="has-text-centered">{{ item.valor_aplicado | amount }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="5">TOTAL:</td>
                                <td class="has-text-centered">
                                    {{ orden.monto_con_impuesto | amount }}
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="nj-flex">
                    <Button label="Pagar"
                            icon="money"
                            color="blue"
                            :activation="activarOpcion('pagar')"
                            @click="pagarOrden()"
                            activationCode="pagar_orden_compra"></Button>
                </div>
                <TransferenciaOrdenCompra v-if="activarTransferenciaOrdenCompra"
                                          :ord_id="ord_id"
                                          :pry_id="pry_id"
                                          @close="popup($event)"></TransferenciaOrdenCompra>
                <TransferenciaItemsDetallexOrdenView v-if="activarTransferenciaDetallexOrden"
                                                     :ord_id="orden.id_orden"
                                                     @close="popup($event)"></TransferenciaItemsDetallexOrdenView>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { CondicionComercialEnum } from "../constants"
import { Button } from "../modules/components"
import TransferenciaItemsDetallexOrdenView from "../modules/transferenciaItems/TransferenciaItemsDetallexOrdenView"
import TransferenciaOrdenCompra from "../modules/transferenciaItems/TransferenciaOrdenCompra"
import OrdenArchivos from "./OrdenArchivos"
import { Confirm } from "../util"
import { purchaseStatus } from "../constants/constants"
import { UsuarioService } from "../services"
import { store } from '../store'
export default {
    name: "OrdenView",
    components: {
        OrdenArchivos,
        TransferenciaOrdenCompra,
        TransferenciaItemsDetallexOrdenView,
        Button,
    },
    data() {
        return {
            orden: {},
            isMostrarPagos: false,
            activarTransferenciaOrdenCompra: false,
            activarTransferenciaDetallexOrden: false,
            ord_id: null,
            pry_id: null,
        }
    },
    methods: {
        loadOrdenData() {
            axios
                .post(
                    "/orden/get-orden-detail",
                    {},
                    {
                        headers: {
                            idOrden: this.getIdOrden()
                        }
                    })
                .then(
                    resp => {
                        this.orden = resp.data
                        this.$emit('load-orden', this.orden)
                    },
                    () => { })
                .finally(() => {
                    this.mostrarPagos()
                })
        },
        getIdOrden() {
            let path = window.location.pathname
            return path.split("/")[3]
        },
        ordenesPago() {
            this.$router.push({
                name: "ordenPago",
                params: {
                    ord_id: this.orden.id_orden
                }
            })
        },
        mostrarPagos() {
            if (this.orden.condicion_comercial.id_condicion == CondicionComercialEnum.ADELANTO.coc_id
                || this.orden.condicion_comercial.id_condicion == CondicionComercialEnum.ADELANTO_15.coc_id
                || this.orden.condicion_comercial.id_condicion == CondicionComercialEnum.ADELANTO_50.coc_id
                || this.orden.condicion_comercial.id_condicion == CondicionComercialEnum.CREDITO.coc_id) {
                this.isMostrarPagos = true
            } else {
                this.isMostrarPagos = false
            }
        },
        calcularBaseImponible() {
            const igv = this.orden.orden_impuestos.find(item => item.descripcion == "IGV")
            const simbolo = this.orden.moneda.simbolo
            if (igv) {
                return `${simbolo} ${this.orden.monto_sin_impuesto + igv.valor_aplicado}`
            } else {
                return `${simbolo} ${this.orden.monto_sin_impuesto}`
            }
        },
        popup({
            interfaz,
            activar,
        }) {
            switch (interfaz) {
                case "TransferenciaOrdenCompra":
                    this.activarTransferenciaOrdenCompra = activar
                    this.ord_id = this.orden.id_orden
                    this.pry_id = this.orden.centro_costo.pry_id
                    break
                case "TransferenciaItemsDetallexOrdenView":
                    this.activarTransferenciaItemsDetallexOrdenView = activar
                    break
            }
        },
        activarOpcion(opcion) {
            let condicion = false
            switch (opcion) {
                case "pagar":
                    condicion = this.orden.estado.id_orden_estado == purchaseStatus.EMITIDO.id
                    break
            }
            return condicion
        },
        pagarOrden() {
            Confirm.show({
                message: "¿Desea pagar la orden?",
                action: () => {
                    axios({
                        method: "POST",
                        url: "/orden/approve",
                        headers: { idOrden: this.$route.params.id },
                        data: {
                            id_orden_estado: purchaseStatus.PAGADO.id
                        }
                    })
                        .then(() => {
                            this.$buefy.snackbar.open({
                                message: "Se pago la Orden",
                                type: "is-success",
                                position: "is-top",
                                actionText: "OK",
                                indefinite: true,
                                onAction: () => {
                                    this.$router.push("/orden")
                                }
                            })
                        })
                }
            })
        },
    },
    computed: {
        total_sin_impuesto() {
            if (!this.orden) return 0
            let amount = 0
            this.orden.orden_items.forEach(
                e => (amount += e.cantidad * e.precio_unitario)
            )
            return amount
        },
        total_con_descuento() {
            if (!this.orden) return 0
            let amount = this.total_sin_impuesto
            if (this.tipo_descuento === 1) {
                return amount * (1 - this.orden.descuento)
            } else {
                return amount - this.orden.descuento
            }
        }
    },
    beforeMount() {
        UsuarioService.obtenerOpciones()
    },
    mounted() {
        this.loadOrdenData()
    }
}
</script>

<style scoped></style>